import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsEvent } from '../../../../lib/analytics/events';
import { useAnalytics } from '../../../../lib/analytics/use-analytics';
import { useDaysSinceLastInteraction } from '../../../bonus-feed/features/recognition/components/tracker-widget/hooks/use-interaction';
import { DirectReportCard } from './direct-report-card';
import { EnrichedDirectReport } from './direct-report-list';

interface DirectReportRowProps {
	directReport: EnrichedDirectReport;
}

export const DirectReportRow: FC<DirectReportRowProps> = ({ directReport }) => {
	const { t } = useTranslation(['tracker_widget']);
	const { track } = useAnalytics();

	const daysSinceInteraction = useDaysSinceLastInteraction(directReport.lastRecognizedAt);

	const lastRecognizedText = useMemo(() => {
		if (!directReport.lastRecognizedAt) {
			return t('tracker_widget:person_list.never_interacted');
		}
		if (daysSinceInteraction === 0) {
			return t('tracker_widget:person_list.last_interacted_today');
		}
		return t('tracker_widget:person_list.last_interacted', { count: daysSinceInteraction });
	}, [directReport.lastRecognizedAt, daysSinceInteraction, t]);

	return (
		<DirectReportCard
			user={directReport}
			subtitle={lastRecognizedText}
			onRowClick={() => track(AnalyticsEvent.TeamPanel.LinkClicked, { link: 'Team Member', directReportId: directReport.id })}
			onMenuOpen={() => track(AnalyticsEvent.TeamPanel.DirectReportActionMenuOpened, { directReportId: directReport.id })}
			onMenuAction={(action) => track(AnalyticsEvent.TeamPanel.DirectReportActionClicked, { directReportId: directReport.id, action })}
		/>
	);
};
